import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from '../../containers/Text';
import './HomePage.scss';

const VideoGuidesSection = () => {
  const { t, i18n } = useTranslation();

  return (
    <section className="video-guides-section">
      <h3 className="video-guides-title">
        <Text text={t('video-guides-title')} />
      </h3>
      <div>
        {i18n.language === 'heb' ? (
          <a
            href="https://www.youtube.com/watch?v=Z9QALklfnCo&feature=youtu.be"
            target="_blank"
            className="video-card hebrew-video"
          >
            <div className="video-icon">
              <Text text={<i data-lucide="youtube" className="youtube-icon" />} />
            </div>
            <div className="video-content">
              <h4 className="video-title">
                <Text text={t('hebrew-video-title')} />
              </h4>
              <p className="video-description">
                <Text text={t('hebrew-video-description')} />
              </p>
            </div>
          </a>
        ) : (
          <a
            href="https://www.youtube.com/watch?v=XRiQzs3t8gU"
            target="_blank"
            className="video-card english-video"
          >
            <div className="video-icon">
              <Text text={<i data-lucide="youtube" className="w-8 h-8" />} />
            </div>
            <div className="video-content">
              <h4 className="video-title">
                <Text text={t('english-video-title')} />
              </h4>
              <p className="video-description">
                <Text text={t('english-video-description')} />
              </p>
            </div>
          </a>
        )}
      </div>
    </section>
  );
};

export default VideoGuidesSection;
